import React from 'react';

import TimeHourGrid from '../../TimeHourGrid';
import { SectionBlock, SectionTitle } from '../styles';
import type { TimeShiftSectionProps } from './types';

const TimeShiftSection = (props: TimeShiftSectionProps) => {
  const { hours, title, hasOnlyOneShift, selectedMinutes, onSelectHour } = props;

  if (hours.length === 0) {
    return null;
  }

  return (
    <SectionBlock>
      {!hasOnlyOneShift ? <SectionTitle>{title}</SectionTitle> : null}
      <TimeHourGrid hours={hours} selectedMinutes={selectedMinutes} onSelectHour={onSelectHour} />
    </SectionBlock>
  );
};

export default TimeShiftSection;
